
import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

export default function CaseDetail() {
  const { id } = useParams();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const caseStudies = [
    {
      id: 1,
      category: 'ヤニ汚れ',
      title: 'タバコのヤニで黄ばんだ壁紙の再生',
      location: 'さいたま市浦和区 1K アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/b73da1dfaaf3884917b520b664ddb1c6.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/32dbd8c94356c3b6fe38f58b02ba28dc.jfif',
      description: '長年のタバコのヤニで黄色く変色した壁紙を、クロスメイクで真っ白に再生。臭いも完全に除去されました。',
      workTime: '2時間30分',
      cost: '28,000円',
      area: '18㎡',
      roomType: '1K',
      challenge: 'タバコを10年以上吸い続けた部屋で、壁紙全体が黄色く変色していました。特に窓際や換気扇周りは茶色に近い状態でした。',
      solution: '特殊な下地処理を行った後、ヤニ専用のクロスメイク剤を2回塗布。消臭効果のある仕上げ剤で完全に臭いを除去しました。',
      result: '真っ白な壁紙に再生され、タバコの臭いも完全に消失。オーナー様からは「新築のようだ」とお喜びいただきました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/b73da1dfaaf3884917b520b664ddb1c6.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/32dbd8c94356c3b6fe38f58b02ba28dc.jfif',
          caption: '全体の様子'
        },
        {
          before: 'https://public.readdy.ai/ai/img_res/c14c51c2c7c7ad2ca1316a28947667ae.jpg',
          after: 'https://readdy.ai/api/search-image?query=close%20up%20view%20of%20perfectly%20white%20restored%20wallpaper%20after%20treatment%20showing%20pristine%20clean%20texture%20in%20Japanese%20apartment&width=400&height=300&seq=nicotine-detail-after&orientation=landscape',
          caption: '詳細部分'
        }
      ]
    },
    {
      id: 2,
      category: 'ヤニ汚れ',
      title: '重度のヤニ汚れもダブルコーティングで対応',
      location: 'さいたま市見沼区 1K アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/42ff4b4ccb41e02a533777ccd71db5c6.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/479c0830b41cbd6cf814b5b22dd76158.jfif',
      description: '10年以上のヘビースモーカーによる重度のヤニ汚れも、ダブルコーティング技術で完全に白く再生しました。',
      workTime: '3時間30分',
      cost: '38,000円',
      area: '20㎡',
      roomType: '1K',
      challenge: '10年以上ヘビースモーカーが住んでいた部屋で、壁紙が茶色に変色し、通常の施工では対応困難な状態でした。',
      solution: 'ダブルコーティング技術を採用し、特殊な下地処理と2回のコーティングで完全に白く再生しました。',
      result: '重度のヤニ汚れも完全に除去され、臭いも消失。張替えと同等の仕上がりを実現しました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/42ff4b4ccb41e02a533777ccd71db5c6.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/479c0830b41cbd6cf814b5b22dd76158.jfif',
          caption: '全体の様子'
        }
      ]
    },
    {
      id: 3,
      category: 'ヤニ汚れ',
      title: 'ワンルームのヤニ汚れ完全除去',
      location: 'さいたま市緑区 1R アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/f914c8aff93c23446a16812ed9c7ed23.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/6418748284d5b8f9d734e876c571fd86.jfif',
      description: '5年間のヘビースモーカーが住んでいたワンルームのヤニ汚れを、特殊洗浄とクロスメイクで新品同様に再生。',
      workTime: '2時間45分',
      cost: '26,000円',
      area: '16㎡',
      roomType: '1R',
      challenge: '5年間ヘビースモーカーが住んでいたワンルームで、壁紙全体が黄色く変色し、特に天井付近の汚れが目立っていました。',
      solution: '特殊洗浄で表面の汚れを除去した後、ヤニ専用のクロスメイク剤で全体を白く再生しました。',
      result: '新品同様の白い壁紙に再生され、ヤニの臭いも完全に除去。次の入居者からも高評価をいただきました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/f914c8aff93c23446a16812ed9c7ed23.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/6418748284d5b8f9d734e876c571fd86.jfif',
          caption: '全体の様子'
        }
      ]
    },
    {
      id: 4,
      category: 'カビ汚れ',
      title: '湿気によるカビ汚れの完全除去',
      location: 'さいたま市南区 1DK マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/7f682debfceb0eeee340d1f2d53d7700.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/e988cfed0a06c95d389add44e7c4f709.jfif',
      description: '浴室近くの湿気でカビが発生した壁紙を、抗菌・防カビ効果のあるクロスメイクで清潔に再生しました。',
      workTime: '3時間',
      cost: '35,000円',
      area: '25㎡',
      roomType: '1DK',
      challenge: '浴室に隣接する部屋で、湿気により壁紙に黒いカビが広範囲に発生していました。',
      solution: 'カビ除去専用の前処理を行い、抗菌・防カビ効果のあるクロスメイク剤で施工。湿気対策も併せて実施しました。',
      result: 'カビが完全に除去され、防カビ効果により再発を防止。清潔で健康的な室内環境を実現しました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/7f682debfceb0eeee340d1f2d53d7700.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/e988cfed0a06c95d389add44e7c4f709.jfif',
          caption: '全体の様子'
        }
      ]
    },
    {
      id: 5,
      category: 'カビ汚れ',
      title: '北側部屋の黒カビ除去',
      location: 'さいたま市西区 1K マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/83ccc35d4edeca16fae99a7a186c68db.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/c8e53857b274e4665a01074b2c2ec01d.jfif',
      description: '日当たりの悪い北側部屋に発生した黒カビを、専用の除菌処理とクロスメイクで完全に除去し、防カビ効果も付与。',
      workTime: '2時間30分',
      cost: '29,000円',
      area: '19㎡',
      roomType: '1K',
      challenge: '日当たりの悪い北側部屋で、湿気により黒カビが広範囲に発生し、健康面での懸念がありました。',
      solution: '専用の除菌処理で黒カビを根本から除去し、防カビ効果のあるクロスメイク剤で再発を防止しました。',
      result: '黒カビが完全に除去され、清潔で健康的な室内環境を実現。防カビ効果で長期間安心です。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/83ccc35d4edeca16fae99a7a186c68db.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/c8e53857b274e4665a01074b2c2ec01d.jfif',
          caption: '全体の様子'
        }
      ]
    },
    {
      id: 6,
      category: 'カビ汚れ',
      title: '結露によるカビ汚れの再生',
      location: 'さいたま市中央区 1DK アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/53f15e639f524919ffb61fdcfb4a42ee.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/72d69dad60f6c78c3c31a260b539edde.jfif',
      description: '冬場の結露で発生したカビ汚れを、根本的な除菌処理とクロスメイクで清潔に再生。再発防止効果も実現。',
      workTime: '3時間15分',
      cost: '33,000円',
      area: '23㎡',
      roomType: '1DK',
      challenge: '冬場の結露により窓周りを中心にカビが発生し、室内の空気環境が悪化していました。',
      solution: '根本的な除菌処理を行い、結露対策も含めたクロスメイクで清潔に再生しました。',
      result: 'カビが完全に除去され、再発防止効果により長期間清潔な状態を維持できています。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/53f15e639f524919ffb61fdcfb4a42ee.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/72d69dad60f6c78c3c31a260b539edde.jfif',
          caption: '全体の様子'
        }
      ]
    },
    {
      id: 7,
      category: '換気扇・換気口',
      title: '換気扇周りの油汚れとホコリの除去',
      location: 'さいたま市大宮区 1R アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/0c0b3690a7315279fb66c272f710923b.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/40b7e1838f92ad4641fc8ac9573f91a8.jfif',
      description: 'キッチンの換気扇周りに付着した調理油とホコリによる黒ずみを、短時間で真っ白に再生しました。',
      workTime: '2時間',
      cost: '25,000円',
      area: '15㎡',
      roomType: '1R',
      challenge: 'キッチンの換気扇周りに長年蓄積した調理油とホコリが混ざった頑固な汚れが付着していました。',
      solution: '油汚れ専用の洗浄剤で前処理を行い、クロスメイクで白く再生。換気扇周りの細かい部分も丁寧に施工しました。',
      result: '換気扇周りが真っ白になり、キッチン全体が清潔な印象に。入居者の満足度も大幅に向上しました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/0c0b3690a7315279fb66c272f710923b.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/40b7e1838f92ad4641fc8ac9573f91a8.jfif',
          caption: '換気扇周り'
        }
      ]
    },
    {
      id: 8,
      category: '換氣扇・換氣口',
      title: 'トイレ換氣扇周りの汚れ除去',
      location: 'さいたま市桜区 1K アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/015e8e610d79d7be10f6a74e785ac523.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/be0608289c0e26546586704651cac96b.jfif',
      description: 'トイレの換氣扇周りに蓄積した湿気とホコリによる汚れを、専用洗浄とクロスメイクで清潔に再生。',
      workTime: '1時間45分',
      cost: '22,000円',
      area: '12㎡',
      roomType: '1K',
      challenge: 'トイレの換氣扇周りに湿気とホコリが蓄積し、黒ずみや汚れが目立っていました。',
      solution: '湿気汚れ専用の洗浄剤で前処理を行い、クロスメイクで清潔に再生しました。',
      result: 'トイレ全体が清潔な印象になり、換氣扇周りも真っ白に再生されました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/015e8e610d79d7be10f6a74e785ac523.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/be0608289c0e26546586704651cac96b.jfif',
          caption: 'トイレ換氣扇周り'
        }
      ]
    },
    {
      id: 9,
      category: '換氣扇・換氣口',
      title: '浴室換氣扇周りの黒ずみ除去',
      location: 'さいたま市岩槻区 1DK マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/c50ae2ef9baeab7e1fe15d6329943eec.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/843170201ebb433e085f0dd9b65b29e9.jfif',
      description: '浴室の換氣扇周りに発生した湿気による黒ずみを、防カビ処理とクロスメイクで完全に除去し、清潔な状態に。',
      workTime: '2時間15分',
      cost: '27,000円',
      area: '17㎡',
      roomType: '1DK',
      challenge: '浴室の換氣扇周りに湿気による黒ずみが発生し、カビの発生も懸念されていました。',
      solution: '防カビ処理を行った後、湿気に強いクロスメイク剤で施工し、清潔な状態に再生しました。',
      result: '黒ずみが完全に除去され、防カビ効果により清潔な状態を長期間維持できています。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/c50ae2ef9baeab7e1fe15d6329943eec.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/843170201ebb433e085f0dd9b65b29e9.jfif',
          caption: '浴室換氣扇周り'
        }
      ]
    },
    {
      id: 10,
      category: '冷蔵庫裏',
      title: '家具裏の隠れた汚れもきれいに',
      location: 'さいたま市中央区 1LDK マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/1caa93d67b3fbdf59b84cc83ac34f3e5.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/7d82143fe9c0beb9e038ea68b2e98957.jfif',
      description: '冷蔵庫を動かさずに、裏側のシミや黒ずみをきれいにリメイク。家具の配置を変えずに施工完了。',
      workTime: '2時間45分',
      cost: '32,000円',
      area: '22㎡',
      roomType: '1LDK',
      challenge: '冷蔵庫の裏側に長年の湿気や汚れによるシミが発生していましたが、重い冷蔵庫を動かすのは困難でした。',
      solution: '冷蔵庫を動かさずに施工できる特殊な工具を使用し、狭いスペースでも確実にクロスメイクを実施しました。',
      result: '冷蔵庫を動かすことなく、裏側の汚れを完全に除去。オーナー様の負担を最小限に抑えました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/1caa93d67b3fbdf59b84cc83ac34f3e5.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/7d82143fe9c0beb9e038ea68b2e98957.jfif',
          caption: '冷蔵庫裏'
        }
      ]
    },
    {
      id: 11,
      category: '冷蔵庫裏',
      title: '洗濯機裏の湿気による汚れ除去',
      location: 'さいたま市浦和区 1K アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/6a9c2d503d3f7f05ea12fc4bf4675159.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/27f67e53dd04b89476d012dae839ad86.jfif',
      description: '洗濯機裏の湿気とホコリによる汚れを、家電を動かすことなく専用工具でクロスメイク施工。',
      workTime: '2時間30分',
      cost: '28,000円',
      area: '18㎡',
      roomType: '1K',
      challenge: '洗濯機裏に湿気とホコリが蓄積し、汚れやシミが発生していましたが、重い洗濯機を動かすのは困難でした。',
      solution: '専用工具を使用して洗濯機を動かすことなく、狭いスペースでもクロスメイクを実施しました。',
      result: '洗濯機を動かすことなく、裏側の汚れを完全に除去。オーナー様の負担を軽減しました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/6a9c2d503d3f7f05ea12fc4bf4675159.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/27f67e53dd04b89476d012dae839ad86.jfif',
          caption: '洗濯機裏'
        }
      ]
    },
    {
      id: 12,
      category: '冷蔵庫裏',
      title: '電子レンジ台裏の油汚れ除去',
      location: 'さいたま市北区 1R アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/2d0b5d23cedb04d0826c7ad387d517d0.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/ff6f070779eb3e559bad9ca9d0906acc.jfif',
      description: '電子レンジ台裏に飛び散った調理油による汚れを、家電を移動せずに特殊洗浄とクロスメイクで除去。',
      workTime: '2時間',
      cost: '24,000円',
      area: '14㎡',
      roomType: '1R',
      challenge: '電子レンジ台裏に調理油が飛び散り、汚れが蓄積していましたが、家電を移動するのは困難でした。',
      solution: '油汚れ専用の洗浄剤で前処理を行い、家電を移動せずにクロスメイクで清潔に再生しました。',
      result: '家電を移動することなく、油汚れを完全に除去。キッチン全体が清潔な印象になりました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/2d0b5d23cedb04d0826c7ad387d517d0.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/ff6f070779eb3e559bad9ca9d0906acc.jfif',
          caption: '電子レンジ台裏'
        }
      ]
    },
    {
      id: 13,
      category: '手垢・汚れ',
      title: '日常生活による手垢や汚れの除去',
      location: 'さいたま市桜区 2DK アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/8d9303e862c907034f637786287e7f19.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/27c5b35d6a18feb70fe40471669195a6.jfif',
      description: 'スイッチ周りや扉付近の手垢、子供の落書きなど日常生活による汚れを完全に除去し、新品同様に再生。',
      workTime: '4時間',
      cost: '45,000円',
      area: '35㎡',
      roomType: '2DK',
      challenge: 'ファミリー世帯が長期間住んでいた部屋で、スイッチ周りの手垢、子供の落書き、家具の跡など様々な汚れがありました。',
      solution: '汚れの種類に応じて異なる前処理を行い、クロスメイクで統一感のある白い仕上がりに再生しました。',
      result: '新品同様の白い壁紙に再生され、次の入居者からも高い評価をいただきました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/8d9303e862c907034f637786287e7f19.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/27c5b35d6a18feb70fe40471669195a6.jfif',
          caption: '全体の様子'
        }
      ]
    },
    {
      id: 14,
      category: '手垢・汚れ',
      title: 'コンセント周りの汚れ除去',
      location: 'さいたま市南区 1K マンション',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/2cef8a541f036f799490f2a0d4bb013c.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/26391431238c1975606bdee247f44231.jfif',
      description: '電気スイッチ周りに蓄積した手垢や汚れを、丁寧な前処理とクロスメイクで新品同様の白さに再生。',
      workTime: '2時間30分',
      cost: '28,000円',
      area: '18㎡',
      roomType: '1K',
      challenge: '電気スイッチやコンセント周りに長年の手垢や汚れが蓄積し、黒ずみが目立っていました。',
      solution: '丁寧な前処理で汚れを除去した後、クロスメイクで新品同様の白さに再生しました。',
      result: 'スイッチ周りが新品同様の白さに再生され、部屋全体が清潔な印象になりました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/2cef8a541f036f799490f2a0d4bb013c.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/26391431238c1975606bdee247f44231.jfif',
          caption: 'コンセント周り'
        }
      ]
    },
    {
      id: 15,
      category: '手垢・汚れ',
      title: '換氣フード周りの黒ずみ汚れ除去',
      location: 'さいたま市大宮区 1DK アパート',
      before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/4d45c21b92c9701455cc929fdc7e1ba2.jfif',
      after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/0ce7b46bde9d67fa2f7e141d267e2a1b.jfif',
      description: '換氣扇フードまわりの黒ずみを、特殊洗浄とクロスメイクで完全に除去し、清潔な印象に。',
      workTime: '3時間',
      cost: '32,000円',
      area: '21㎡',
      roomType: '1DK',
      challenge: '換氣扇フード周りに調理による油汚れと手垢が混ざった黒ずみが発生していました。',
      solution: '特殊洗浄で頑固な汚れを除去した後、クロスメイクで清潔な白い仕上がりに再生しました。',
      result: '換氣扇フード周りが清潔な印象になり、キッチン全体の美観が向上しました。',
      images: [
        {
          before: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/4d45c21b92c9701455cc929fdc7e1ba2.jfif',
          after: 'https://static.readdy.ai/image/230539a841f231148071772f0f8de6bf/0ce7b46bde9d67fa2f7e141d267e2a1b.jfif',
          caption: '換氣フード周り'
        }
      ]
    }
  ];

  const caseStudy = caseStudies.find(study => study.id === parseInt(id || '1'));

  // SEO対策のためのmeta情報を動的に設定
  useEffect(() => {
    if (caseStudy) {
      // ページタイトルを設定
      document.title = `${caseStudy.title} - 壁紙張替え・クロス交換不要の施工事例詳細 | 壁紙革命浦和`;
      
      // meta descriptionを設定
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', 
          `${caseStudy.title}の詳細施工事例。${caseStudy.location}での壁紙張替え不要のクロスメイク実績。退去費用${caseStudy.cost}、施工時間${caseStudy.workTime}でクロス汚れを完全除去。壁紙交換やクロス部分張替えに代わる革新的なクロス工事の詳細をご紹介。`
        );
      }

      // キーワードを設定
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', 
          `壁紙張替え,クロス交換,壁紙交換,クロス部分張替え,クロス汚れ,退去費用,クロス張替え,クロス工事,${caseStudy.category},${caseStudy.location},原状回復,賃貸物件`
        );
      }
    }

    return () => {
      // クリーンアップ時に元のタイトルに戻す
      document.title = '壁紙革命浦和 - 壁紙張替え・クロス交換不要！賃貸物件オーナー様の味方。壁紙を張り替えずに新品同様に再生します';
    };
  }, [caseStudy]);

  if (!caseStudy) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">施工事例が見つかりません</h1>
          <Link to="/before-after" className="text-teal-600 hover:text-teal-700 cursor-pointer">
            壁紙張替え不要の施工事例一覧に戻る
          </Link>
        </div>
      </div>
    );
  }

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % caseStudy.images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + caseStudy.images.length) % caseStudy.images.length);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="bg-white shadow-sm border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-4">
              <div className="text-2xl font-bold text-teal-600" style={{ fontFamily: 'Pacifico, serif' }}>
                クロスメイク浦和
              </div>
              <div className="text-lg font-bold text-navy-800 bg-teal-50 px-4 py-2 rounded-lg">
                オーナー様の味方
              </div>
            </Link>
            <nav className="hidden md:flex space-x-6">
              <Link to="/#service" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                サービス内容
              </Link>
              <Link to="/#case-studies" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                施工事例
              </Link>
              <Link to="/#pricing" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                料金
              </Link>
              <Link to="/#faq" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                よくある質問
              </Link>
              <Link to="/#company" className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors">
                会社概要
              </Link>
            </nav>
            <div className="text-sm text-gray-600">TEL: 048-614-1544</div>
          </div>
        </div>
      </header>

      {/* パンくずリスト */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-teal-600 hover:text-teal-700 cursor-pointer">
              ホーム
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <Link to="/before-after" className="text-teal-600 hover:text-teal-700 cursor-pointer">
              壁紙張替え不要の施工事例一覧
            </Link>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-600">{caseStudy.title}</span>
          </nav>
        </div>
      </div>

      {/* メイン画像セクション */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-8">
              <div className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
                {caseStudy.category} - 壁紙張替え不要
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                {caseStudy.title}
              </h1>
              <p className="text-lg text-gray-600 mb-4">
                {caseStudy.location}
              </p>
              <div className="text-base text-gray-700 bg-teal-50 inline-block px-6 py-3 rounded-lg">
                <strong>壁紙交換・クロス部分張替え不要で退去費用を大幅削減</strong>
              </div>
            </div>

            {/* ビフォーアフター画像 */}
            <div className="relative bg-gray-100 rounded-lg overflow-hidden mb-8">
              <div className="grid md:grid-cols-2">
                <div className="relative">
                  <img
                    src={caseStudy.images[currentImageIndex].before}
                    alt={`${caseStudy.title} - 壁紙張替え前のクロス汚れ状態`}
                    className="w-full h-96 object-cover"
                  />
                  <div className="absolute top-4 left-4 bg-red-500 text-white px-4 py-2 rounded font-semibold">
                    クロス交換前
                  </div>
                </div>
                <div className="relative">
                  <img
                    src={caseStudy.images[currentImageIndex].after}
                    alt={`${caseStudy.title} - 壁紙張替え不要のクロス工事完了後`}
                    className="w-full h-96 object-cover"
                  />
                  <div className="absolute top-4 left-4 bg-green-500 text-white px-4 py-2 rounded font-semibold">
                    クロス工事完了
                  </div>
                </div>
              </div>

              {caseStudy.images.length > 1 && (
                <>
                  <button
                    onClick={prevImage}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white p-3 rounded-full shadow-md cursor-pointer transition-colors"
                  >
                    <i className="ri-arrow-left-line text-xl text-gray-700"></i>
                  </button>
                  <button
                    onClick={nextImage}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white/80 hover:bg-white p-3 rounded-full shadow-md cursor-pointer transition-colors"
                  >
                    <i className="ri-arrow-right-line text-xl text-gray-700"></i>
                  </button>
                </>
              )}

              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/50 text-white px-4 py-2 rounded-full">
                {caseStudy.images[currentImageIndex].caption}
              </div>
            </div>

            {/* 画像インジケーター */}
            <div className="flex justify-center mb-8 space-x-2">
              {caseStudy.images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImageIndex(index)}
                  className={`w-3 h-3 rounded-full cursor-pointer transition-colors ${
                    index === currentImageIndex ? 'bg-teal-600' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>

            {/* 施工詳細情報 */}
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-gray-50 p-8 rounded-lg">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">壁紙張替え不要の施工概要</h2>
                <div className="space-y-4">
                  <div className="flex justify-between">
                    <span className="text-gray-600">物件タイプ：</span>
                    <span className="font-semibold text-gray-800">{caseStudy.roomType}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">施工面積：</span>
                    <span className="font-semibold text-gray-800">{caseStudy.area}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">クロス工事時間：</span>
                    <span className="font-semibold text-gray-800">{caseStudy.workTime}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">退去費用削減額：</span>
                    <span className="font-semibold text-teal-600 text-lg">{caseStudy.cost}</span>
                  </div>
                </div>
              </div>

              <div className="bg-teal-50 p-8 rounded-lg">
                <h2 className="text-2xl font-bold text-gray-800 mb-6">クロス交換との比較メリット</h2>
                <div className="space-y-4">
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-teal-600 mt-1 text-lg"></i>
                    <span className="text-gray-700">壁紙張替えの約半額の退去費用を実現</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-teal-600 mt-1 text-lg"></i>
                    <span className="text-gray-700">クロス部分張替えより短時間で空室期間を短縮</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-teal-600 mt-1 text-lg"></i>
                    <span className="text-gray-700">クロス交換不要で環境に優しい工法</span>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-check-line text-teal-600 mt-1 text-lg"></i>
                    <span className="text-gray-700">壁紙張替えと同等の新品同様の仕上がり</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 施工プロセス */}
            <div className="bg-white border rounded-lg p-8 mb-12">
              <h2 className="text-2xl font-bold text-gray-800 mb-8 text-center">壁紙張替え不要のクロス工事プロセス</h2>
              
              <div className="space-y-8">
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                    <span className="bg-red-5 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                    クロス汚れの状況
                  </h3>
                  <p className="text-gray-700 leading-relaxed ml-11">
                    {caseStudy.challenge}
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                    <span className="bg-blue-5 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                    壁紙交換に代わる解決方法
                  </h3>
                  <p className="text-gray-700 leading-relaxed ml-11">
                    {caseStudy.solution}
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                    <span className="bg-green-5 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                    クロス工事完了後の結果
                  </h3>
                  <p className="text-gray-700 leading-relaxed ml-11">
                    {caseStudy.result}
                  </p>
                </div>
              </div>
            </div>

            {/* SEO強化セクション */}
            <div className="bg-gradient-to-r from-teal-50 to-blue-50 p-8 rounded-lg mb-12">
              <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                なぜ壁紙張替えではなくクロスメイクを選ぶのか
              </h2>
              <div className="grid md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-4">従来のクロス交換・壁紙張替えの課題</h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-close-line text-red-500 mt-1 mr-2"></i>
                      <span>高額な退去費用（1Kで約5-8万円）</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-line text-red-500 mt-1 mr-2"></i>
                      <span>クロス部分張替えでも色合わせが困難</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-line text-red-500 mt-1 mr-2"></i>
                      <span>長時間のクロス工事で空室期間延長</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-close-line text-red-500 mt-1 mr-2"></i>
                      <span>大量のクロス廃材による環境負荷</span>
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-4">クロスメイクの優位性</h3>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-line text-teal-600 mt-1 mr-2"></i>
                      <span>壁紙張替えの約半額で退去費用削減</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-teal-600 mt-1 mr-2"></i>
                      <span>クロス汚れを均一に除去し色ムラなし</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-teal-600 mt-1 mr-2"></i>
                      <span>2-3時間の短時間クロス工事</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-teal-600 mt-1 mr-2"></i>
                      <span>壁紙交換不要で廃材ほぼゼロ</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* CTA */}
            <div className="text-center">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">
                同じようなクロス汚れでお困りですか？
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                壁紙張替えやクロス部分張替えをお考えの前に、まずはクロスメイクをご検討ください。<br />
                退去費用を大幅に削減できる可能性があります。
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/#estimate-form"
                  className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  作業依頼する
                </Link>
                <a
                  href="tel:048-614-1544"
                  className="bg-white hover:bg-gray-50 text-gray-800 px-8 py-4 rounded-lg text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap border border-gray-200"
                >
                  電話で相談する
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 関連事例 */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">その他の壁紙張替え不要施工事例</h2>
            <p className="text-lg text-gray-600">
              様々なクロス汚れに対応した退去費用削減事例をご紹介
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {caseStudies
              .filter(study => study.id !== caseStudy.id)
              .slice(0, 3)
              .map((study) => (
                <div key={study.id} className="bg-white rounded-lg shadow-md overflow-hidden">
                  <div className="relative">
                    <div className="grid grid-cols-2">
                      <img
                        src={study.before}
                        alt={`${study.title} - クロス交換前`}
                        className="w-full h-32 object-cover"
                      />
                      <img
                        src={study.after}
                        alt={`${study.title} - 壁紙張替え不要で再生後`}
                        className="w-full h-32 object-cover"
                      />
                    </div>
                    <div className="absolute top-2 right-2 bg-teal-600 text-white px-2 py-1 rounded text-sm font-semibold">
                      {study.category}
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="font-bold text-gray-800 mb-2 text-sm">
                      {study.title}
                    </h3>
                    <p className="text-gray-600 text-xs mb-3">
                      {study.location}
                    </p>
                    <Link
                      to={`/case-detail/${study.id}`}
                      className="block w-full bg-teal-600 hover:bg-teal-700 text-white text-center py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
                    >
                      詳細を見る
                    </Link>
                  </div>
                </div>
              ))}
          </div>

          <div className="text-center mt-8">
            <Link
              to="/before-after"
              className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              すべての壁紙張替え不要事例を見る
            </Link>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div
                className="text-2xl font-bold text-teal-400 mb-4"
                style={{ fontFamily: 'Pacifico, serif' }}
              >
                壁紙革命浦和
              </div>
              <p className="text-gray-300 mb-4">
                39raリフォーム有限会社　サクラリフォーム<br />
                代表：瀬下尊由希<br />
                TEL: 048-614-1544
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">サービス一覧</h4>
              <ul className="space-y-2 text-gray-300">
                <li>
                  <Link to="/#service" className="hover:text-teal-400 cursor-pointer transition-colors">
                    クロスメイク
                  </Link>
                </li>
                <li>
                  <Link to="/before-after" className="hover:text-teal-400 cursor-pointer transition-colors">
                    施工事例
                  </Link>
                </li>
                <li>
                  <Link to="/#pricing" className="hover:text-teal-400 cursor-pointer transition-colors">
                    料金案内
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">お問い合わせ</h4>
              <div className="space-y-2 text-gray-300">
                <div className="flex items-center">
                  <i className="ri-phone-line mr-2 text-teal-400"></i>
                  <span>048-614-1544</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-time-line mr-2 text-teal-400"></i>
                  <span>平日・土曜 9:00-18:00</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>
              © 2024 39raリフォーム有限会社　サクラリフォーム. All rights reserved.
              <span className="mx-2">|</span>
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-teal-400 transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
